import React from 'react';
import { ModuleConfig } from '../../types/ModuleConfig';

// Import Calculator components (lazy-loaded for performance)
const CalculatorDashboard = React.lazy(() => import('./CalculatorDashboard'));
const CalculatorSubmissions = React.lazy(() => import('./CalculatorSubmissions'));
const CalculatorSettings = React.lazy(() => import('./CalculatorSettings'));

const calculatorModuleConfig: ModuleConfig = {
  // MODULE IDENTITY
  id: 'calculator',
  name: 'Calculator Leads',
  description: 'View and manage calculator form submissions and leads',
  version: '1.0.0',
  enabled: true,
  category: 'marketing',
  order: 16,
  icon: '🧮',
  color: '#38A169', // Green

  // ROUTES
  routes: [
    {
      path: '/calculator',
      component: CalculatorDashboard,
      permissions: ['ADMIN'],
      useLayout: true,
    },
    {
      path: '/calculator/submissions',
      component: CalculatorSubmissions,
      permissions: ['ADMIN'],
      useLayout: true,
    },
    {
      path: '/calculator/settings',
      component: CalculatorSettings,
      permissions: ['ADMIN'],
      useLayout: true,
    },
  ],

  // NAVIGATION
  navigation: [
    {
      label: 'Dashboard',
      path: '/calculator',
      icon: '📊',
      permissions: ['ADMIN'],
    },
    {
      label: 'All Submissions',
      path: '/calculator/submissions',
      icon: '📋',
      permissions: ['ADMIN'],
    },
    {
      label: 'CRM Settings',
      path: '/calculator/settings',
      icon: '⚙️',
      permissions: ['ADMIN'],
    },
  ],

  // PERMISSIONS
  permissions: {
    view: ['ADMIN'],
    create: ['ADMIN'],
    edit: ['ADMIN'],
    delete: ['ADMIN'],
  },

  // QUICK ACTIONS
  quickActions: [
    {
      label: 'View All Submissions',
      path: '/calculator/submissions',
      icon: '📋',
      description: 'See all calculator form submissions',
    },
  ],

  // CHANGELOG
  changelog: [
    {
      version: '1.0.0',
      releaseDate: '2025-12-10',
      title: 'Initial Release - Calculator Lead Capture',
      features: [
        'Lead capture forms on all 12 working calculators',
        'Dashboard with stats and charts',
        'Submissions list with filtering',
        'Status tracking (Pending, Contacted, Qualified, Converted, Closed)',
        'Client linking capability',
        'Pipedrive CRM integration ready',
        'Analytics correlation (visitor ID, session ID, UTM params)',
        'Privacy-compliant IP hashing',
      ],
      notes: 'First stable release of the Calculator Lead Capture module. Transforms calculators into lead generation tools with optional contact capture and comprehensive admin dashboard.',
    },
  ],

  // ROADMAP
  roadmap: [],
};

export default calculatorModuleConfig;
